import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Customer } from 'src/app/model/customer.model';
import { MeterData } from 'src/app/model/meter.model';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss']
})
export class QrcodeComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: Customer ,) { }

  qrcode =this.data.customerId.toString();

  ngOnInit(): void {
    
  }

}
